import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/lib/supabase';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://eventshowcase.de';

const STORIES = [
  {
    name: 'Amara Osei',
    role: 'Music Event Organizer',
    location: 'Accra, Ghana',
    avatar: 'https://public.readdy.ai/ai/img_res/06ee48e3e9b14ab47251b5e4fa04b39c.jpg',
    cover: 'https://readdy.ai/api/search-image?query=afrobeats%20music%20concert%20ghana%20accra%20crowd%20dancing%20colorful%20lights%20stage%20performance%20night%20event%20vibrant%20atmosphere&width=600&height=340&seq=story-cover-1&orientation=landscape',
    quote: 'I went from selling tickets on WhatsApp to running fully automated events. The social follow gate alone grew my Instagram by 4,000 followers in 3 months.',
    stats: [
      { label: 'Tickets Sold', value: '2,400+' },
      { label: 'Revenue', value: '$18,200' },
      { label: 'Followers Gained', value: '4,000+' },
    ],
    plan: 'Growth',
    category: 'Music',
  },
  {
    name: 'Kwame Asante',
    role: 'Tech Conference Host',
    location: 'Lagos, Nigeria',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20african%20man%20smiling%20confident%20clean%20background%20natural%20lighting%20portrait%20photography&width=120&height=120&seq=story-2&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=technology%20conference%20nigeria%20lagos%20keynote%20speaker%20audience%20modern%20venue%20professional%20event%20photography%20clean%20stage&width=600&height=340&seq=story-cover-2&orientation=landscape',
    quote: 'The email campaign feature is a game-changer. I send reminders 1 week and 1 day before each event — my no-show rate dropped from 35% to under 8%.',
    stats: [
      { label: 'Events Hosted', value: '12' },
      { label: 'Attendees', value: '5,800+' },
      { label: 'No-show Rate', value: '&lt;8%' },
    ],
    plan: 'Pro Partner',
    category: 'Tech',
  },
  {
    name: 'Fatima Al-Hassan',
    role: 'Wellness Retreat Organizer',
    location: 'Nairobi, Kenya',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20african%20woman%20natural%20hair%20smiling%20warm%20clean%20background%20portrait%20photography&width=120&height=120&seq=story-3&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=wellness%20yoga%20retreat%20kenya%20nairobi%20outdoor%20group%20session%20peaceful%20nature%20setting%20morning%20light%20serene%20atmosphere&width=600&height=340&seq=story-cover-3&orientation=landscape',
    quote: 'I started on the free plan and upgraded to Growth after my first event sold out. The commission savings paid for the subscription 10x over.',
    stats: [
      { label: 'Retreats Hosted', value: '8' },
      { label: 'Revenue', value: '$24,500' },
      { label: 'Repeat Attendees', value: '68%' },
    ],
    plan: 'Growth',
    category: 'Health',
  },
  {
    name: 'Chidi Nwosu',
    role: 'Comedy Show Producer',
    location: 'Abuja, Nigeria',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20nigerian%20man%20smiling%20confident%20clean%20background%20natural%20lighting%20portrait%20photography&width=120&height=120&seq=story-4&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20show%20nigeria%20abuja%20stand%20up%20comedian%20stage%20spotlight%20laughing%20audience%20intimate%20venue%20night%20event&width=600&height=340&seq=story-cover-4&orientation=landscape',
    quote: 'Team access changed everything. I added my co-producer and marketing manager — now we run 3 shows a month without stepping on each other\'s toes.',
    stats: [
      { label: 'Shows per Month', value: '3' },
      { label: 'Total Attendees', value: '9,200+' },
      { label: 'Team Members', value: '4' },
    ],
    plan: 'Pro Partner',
    category: 'Comedy',
  },
  {
    name: 'Zara Mensah',
    role: 'Fashion Show Director',
    location: 'Kumasi, Ghana',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20ghanaian%20woman%20stylish%20smiling%20clean%20background%20fashion%20portrait%20photography&width=120&height=120&seq=story-5&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=fashion%20show%20ghana%20kumasi%20runway%20models%20elegant%20clothing%20audience%20watching%20stylish%20event%20dramatic%20lighting&width=600&height=340&seq=story-cover-5&orientation=landscape',
    quote: 'The store feature lets me sell merchandise alongside event tickets. My last show generated $3,200 in merch sales on top of ticket revenue.',
    stats: [
      { label: 'Shows Hosted', value: '6' },
      { label: 'Merch Revenue', value: '$12,800' },
      { label: 'Avg Ticket Price', value: '$45' },
    ],
    plan: 'Growth',
    category: 'Fashion',
  },
  {
    name: 'Emmanuel Boateng',
    role: 'Business Summit Organizer',
    location: 'Cape Town, South Africa',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20south%20african%20man%20business%20attire%20smiling%20clean%20background%20portrait%20photography&width=120&height=120&seq=story-6&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=business%20summit%20south%20africa%20cape%20town%20conference%20networking%20modern%20venue%20professional%20event%20photography%20corporate&width=600&height=340&seq=story-cover-6&orientation=landscape',
    quote: 'Homepage spotlight on Pro Partner put my annual summit in front of 50,000+ visitors. Sold out 3 weeks before the event for the first time ever.',
    stats: [
      { label: 'Summit Capacity', value: '800' },
      { label: 'Sold Out In', value: '3 weeks' },
      { label: 'Sponsor Revenue', value: '$40,000' },
    ],
    plan: 'Pro Partner',
    category: 'Business',
  },
];

const PLAN_COLORS: Record<string, string> = {
  'Growth': 'bg-teal-100 text-teal-700',
  'Pro Partner': 'bg-gray-900 text-white',
};

export default function SuccessStoriesPage() {
  const { user, profile } = useAuth();
  const [userRevenue, setUserRevenue] = useState(0);
  const [userTickets, setUserTickets] = useState(0);
  const [userPlan, setUserPlan] = useState('starter');

  const firstName = profile?.full_name?.split(' ')[0] || user?.user_metadata?.full_name?.split(' ')[0] || null;

  useEffect(() => {
    const PAGE_TITLE = 'Success Stories – Real Organizer Results | EVENTSHOWCASE';
    const PAGE_DESC = 'Real success stories from event organizers using EVENTSHOWCASE. See how creators across Africa are growing their audiences and revenue.';
    const PAGE_URL = `${SITE_URL}/success-stories`;
    const PAGE_IMG = 'https://readdy.ai/api/search-image?query=successful%20event%20organizers%20celebrating%20achievement%20crowd%20cheering%20concert%20festival%20africa%20vibrant%20colorful%20energy%20teal%20green&width=1200&height=630&seq=og-success&orientation=landscape';

    document.title = PAGE_TITLE;
    if (user) fetchUserStats();

    const setMeta = (sel: string, attr: string, val: string) => {
      let el = document.querySelector(sel) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); const [a, v] = sel.replace('meta[', '').replace(']', '').split('='); el.setAttribute(a.trim(), v.replace(/"/g, '').trim()); document.head.appendChild(el); el.setAttribute('data-page-meta', 'true'); }
      el.setAttribute(attr, val);
    };
    setMeta('meta[name="description"]', 'content', PAGE_DESC);
    setMeta('meta[property="og:title"]', 'content', PAGE_TITLE);
    setMeta('meta[property="og:description"]', 'content', PAGE_DESC);
    setMeta('meta[property="og:url"]', 'content', PAGE_URL);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:image"]', 'content', PAGE_IMG);
    setMeta('meta[property="og:image:width"]', 'content', '1200');
    setMeta('meta[property="og:image:height"]', 'content', '630');
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', PAGE_TITLE);
    setMeta('meta[name="twitter:description"]', 'content', PAGE_DESC);
    setMeta('meta[name="twitter:image"]', 'content', PAGE_IMG);

    // Schema.org JSON-LD
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Success Stories - Event Organizer Testimonials',
      description: 'Real success stories from event organizers using EVENTSHOWCASE. See how creators across Africa are growing their audiences and revenue.',
      url: `${SITE_URL}/success-stories`,
      isPartOf: {
        '@type': 'WebSite',
        name: 'EVENTSHOWCASE',
        url: SITE_URL,
      },
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: STORIES.map((story, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          item: {
            '@type': 'Article',
            headline: `${story.name} - ${story.role}`,
            description: story.quote,
            author: {
              '@type': 'Person',
              name: story.name,
            },
            image: story.cover,
          },
        })),
      },
    };

    const existing = document.getElementById('schema-success-stories');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'schema-success-stories';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-success-stories');
      if (el) el.remove();
      document.querySelectorAll('meta[data-page-meta="true"]').forEach(e => e.remove());
    };
  }, []);

  const fetchUserStats = async () => {
    if (!user) return;
    const [planRes, eventsRes] = await Promise.all([
      supabase.from('subscriptions').select('plan').eq('user_id', user.id).eq('status', 'active').order('created_at', { ascending: false }).limit(1).maybeSingle(),
      supabase.from('events').select('id').eq('organizer_id', user.id),
    ]);
    setUserPlan(planRes.data?.plan ?? 'starter');
    if (eventsRes.data && eventsRes.data.length > 0) {
      const eventIds = eventsRes.data.map((e: any) => e.id);
      const { data: regs } = await supabase
        .from('registrations')
        .select('total_amount')
        .in('event_id', eventIds)
        .eq('payment_status', 'paid');
      if (regs) {
        setUserRevenue(regs.reduce((s: number, r: any) => s + (Number(r.total_amount) || 0), 0));
        setUserTickets(regs.length);
      }
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar forceScrolled />

      {/* Hero */}
      <section className="pt-28 pb-16 px-4 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-white/15 rounded-full text-xs font-bold uppercase tracking-wide mb-5">
            <i className="ri-star-line"></i> Real Organizers, Real Results
          </span>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            {firstName ? `${firstName}, you could be next` : 'Success Stories'}
          </h1>
          <p className="text-lg text-teal-100 max-w-xl mx-auto">
            {firstName
              ? `See how organizers just like you are growing their audiences and revenue with EVENTSHOWCASE.`
              : 'See how event organizers across Africa are growing their audiences and revenue with EVENTSHOWCASE.'}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-10">
            {[
              { value: '50,000+', label: 'Tickets Sold' },
              { value: '$2M+', label: 'Revenue Generated' },
              { value: '1,200+', label: 'Events Hosted' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-3xl font-extrabold text-white">{stat.value}</p>
                <p className="text-sm text-teal-200 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Personalised progress card */}
          {user && (userRevenue > 0 || userTickets > 0) && (
            <div className="mt-8 inline-block bg-white/10 border border-white/20 rounded-2xl px-6 py-4 text-left">
              <p className="text-xs text-teal-200 font-semibold uppercase tracking-wide mb-3">Your progress so far</p>
              <div className="flex items-center gap-6">
                {userTickets > 0 && (
                  <div className="text-center">
                    <p className="text-2xl font-extrabold text-white">{userTickets}</p>
                    <p className="text-xs text-teal-200">Tickets sold</p>
                  </div>
                )}
                {userRevenue > 0 && (
                  <div className="text-center">
                    <p className="text-2xl font-extrabold text-white">${userRevenue.toFixed(0)}</p>
                    <p className="text-xs text-teal-200">Revenue earned</p>
                  </div>
                )}
                <Link to="/dashboard/earnings" className="text-xs bg-white text-teal-700 font-bold px-3 py-1.5 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap">
                  View Earnings →
                </Link>
              </div>
            </div>
          )}
          {user && userRevenue === 0 && userTickets === 0 && (
            <div className="mt-8 inline-block bg-white/10 border border-white/20 rounded-2xl px-6 py-4">
              <p className="text-sm text-teal-100">Your story starts with your first event.</p>
              <Link to="/create-event" className="inline-flex items-center gap-1.5 mt-2 text-xs bg-white text-teal-700 font-bold px-3 py-1.5 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap">
                <i className="ri-add-line"></i> Create your first event
              </Link>
            </div>
          )}
        </div>
      </section>

      {/* Stories */}
      <section className="max-w-6xl mx-auto px-4 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {STORIES.map((story, i) => (
            <div key={i} className="border border-gray-100 rounded-2xl overflow-hidden">
              {/* Cover */}
              <div className="relative h-48 overflow-hidden">
                <img src={story.cover} alt={story.name} className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <span className={`absolute top-3 right-3 text-[10px] font-bold px-2.5 py-1 rounded-full ${PLAN_COLORS[story.plan]}`}>
                  {story.plan} Plan
                </span>
                <span className="absolute top-3 left-3 bg-white/90 text-gray-700 text-[10px] font-medium px-2 py-0.5 rounded-full">
                  {story.category}
                </span>
              </div>

              <div className="p-6">
                {/* Profile */}
                <div className="flex items-center gap-3 mb-4">
                  <img src={story.avatar} alt={story.name} className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0" />
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{story.name}</p>
                    <p className="text-xs text-gray-500">{story.role} · {story.location}</p>
                  </div>
                </div>

                {/* Quote */}
                <blockquote className="text-sm text-gray-600 leading-relaxed italic border-l-2 border-teal-400 pl-4 mb-5">
                  &ldquo;{story.quote}&rdquo;
                </blockquote>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-3">
                  {story.stats.map((stat, j) => (
                    <div key={j} className="bg-gray-50 rounded-xl p-3 text-center">
                      <p className="text-base font-extrabold text-gray-900" dangerouslySetInnerHTML={{ __html: stat.value }}></p>
                      <p className="text-[10px] text-gray-500 mt-0.5">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-gray-50 py-16 px-4 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Your success story starts here</h2>
          <p className="text-gray-500 text-sm mb-7">Join thousands of organizers already growing with EVENTSHOWCASE.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/signup" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-7 py-3 rounded-xl font-semibold text-sm transition-colors whitespace-nowrap">
              <i className="ri-add-line"></i> Start for Free
            </Link>
            <Link to="/subscribe" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 hover:bg-white px-7 py-3 rounded-xl font-semibold text-sm transition-colors whitespace-nowrap">
              View Plans
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
